import { BaseNotificationContextEnum } from './base-notification-context.enum';

/**
 * Supplier notification context enum
 * @description Notification contexts specific to supplier subjects
 */
export enum SupplierNotificationContextEnum {
	// Base contexts
	INSERTED = BaseNotificationContextEnum.INSERTED,
	UPDATED = BaseNotificationContextEnum.UPDATED,
	DELETED = BaseNotificationContextEnum.DELETED,

	// Supplier-specific contexts
	ACTIVE = 'active',
	ON_HOLD = 'on_hold',
	CLOSED = 'closed',
}
